import Component from '@bythepixel/component-loader';

const closedClass = 'careers-grid-card__content--closed';
const openClass = 'careers-grid-card__button--open';

export default class CareersGridCard extends Component {
  static selector = '[data-comp-careers-grid-card]';

  constructor(containerEl) {
    super(containerEl);
    this.cardText = this.$container.querySelector('[data-comp-careers-grid-card-text]');
    this.cardTrigger = this.$container.querySelector('[data-comp-careers-grid-card-trigger]');

    this.initEventListeners();
  }

  initEventListeners() {
    this.cardTrigger.addEventListener('click', () => {
      if (this.cardText.classList.contains(closedClass)) {
        this.cardTrigger.classList.add(openClass);
        this.cardText.classList.remove(closedClass);
        this.cardText.style.display = 'block';
      } else {
        this.cardTrigger.classList.remove(openClass);
        this.cardText.classList.add(closedClass);
        setTimeout(() => {
          this.cardText.style.display = '-webkit-box';
        }, 200);
      }
    });
  }
}
